import * as React from "react";
function SvgQuestion(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      ref={svgRef}
      {...props}
    >
      <path d="M9.08 17.29a1.37 1.37 0 00-1.37 1.35A1.35 1.35 0 009 20a1.34 1.34 0 001.36-1.31 1.35 1.35 0 00-1.33-1.37zM16 3.76A6.23 6.23 0 009.91 0a6 6 0 00-6.14 4.38 1 1 0 00.74 1.25 1 1 0 001.25-.75 3.9 3.9 0 014.08-2.81 4.15 4.15 0 014.08 2.39c.57 1.57-.23 3.37-2.2 5q-.37.3-.78.57c-1.4 1-3 2.16-3 4.91a1.05 1.05 0 002.1 0c0-1.73.86-2.35 2.15-3.28L13 11c2.78-2.17 3.84-4.86 3-7.24z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgQuestion);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
